import { styled, Theme } from '@mui/material'

export const AlertButton = styled('div')<{
  isSuccess: boolean
  variant?: 'default' | 'outlined'
}>(({
  theme,
  isSuccess,
  variant = 'default',
}: {
  theme: Theme
  isSuccess: boolean
  variant?: 'default' | 'outlined'
}) => {
  const getBackgroundColor = () => {
    if (variant === 'outlined') {
      return isSuccess ? '#ffffff' : theme.colours.base
    }
    return isSuccess ? theme.colours.successColor : theme.colours.base
  }

  const getBorder = () => {
    if (variant === 'outlined' && isSuccess) return `1px solid ${theme.colours.successColor}`

    return 'none'
  }

  const getTextColor = () => {
    if (variant === 'outlined' && isSuccess) return theme.colours.base

    return theme.colours.foreground
  }

  return `
    @keyframes slide-up {
      0% {
        bottom: -50px;
      }
      100% {
        bottom: ${theme.display.ms3};
      }
    }

    position: fixed;
    left: 50%;
    transform: translateX(-50%);

    animation: slide-up 0.2s ease-in;
    animation-fill-mode: forwards;
    display: flex;
    justify-content: space-between;
    padding: ${theme.display.ms1};
    width: 90%;
    max-width: 762px;
    align-items: center;
    box-shadow: ${theme.boxShadow};

    font-size: 16px;
    background-color: ${getBackgroundColor()};
    color: ${getTextColor()};
    border: ${getBorder()};
    border-radius: ${theme.display.borderRadius};
    z-index: ${theme.zIndex?.snackbar};
    white-space: pre-line; // allow \n to break line 

    & button {
      background-color: transparent;
      border: 0;
      cursor: pointer;
      outline: 0 none;
    }
  `
})

export const CloseButton = styled('button')<{
  isSuccess: boolean
  variant?: 'default' | 'outlined'
}>(({
  theme,
  isSuccess,
  variant = 'default',
}: {
  theme: Theme
  isSuccess: boolean
  variant?: 'default' | 'outlined'
}) => {
  const getStrokeColor = () => {
    if (variant === 'outlined' && isSuccess) return theme.colours.base
    return theme.colours.foreground
  }

  return `
    border: 0 none;
    & path {
      stroke: ${getStrokeColor()};
    }
    & > svg {
      width: 20px;
    }
  `
})
